import { render, staticRenderFns } from "./CoursewareContainerActions.vue?vue&type=template&id=b44c2152&"
import script from "./CoursewareContainerActions.vue?vue&type=script&lang=js&"
export * from "./CoursewareContainerActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports